// Shared flag: true while a PeerWindow (an active call) is mounted. The face
// detector reads it to slow its cycle during a call, since the face model and
// the video decoder compete for the same graphics chip and a one-second cadence
// causes visible hitching on modest devices.
import { writable } from "svelte/store";

export const callActive = writable(false);

// Detection cadence while a call is up. A device only drops after
// prefs.faceDetectionSlack (15 s by default) without a face, so three seconds
// still leaves several chances to see the face before that.
export const IN_CALL_DETECTION_INTERVAL_MS = 3000;

// True while the face detector holds the camera open. Drives the on-screen camera
// indicator, which is never hidden while the camera is in use.
export const cameraActive = writable(false);

// After "Cancel" on the opening overlay, stay unavailable until this time (ms since
// epoch) so the same window does not reopen immediately.
export const declineUntil = writable(0);

// Friend uid of the pre-connected window that is open, or null (see links.js).
export const linkOpenWith = writable(null);
export const DECLINE_COOLDOWN_MS = 5 * 60 * 1000;
